import React from 'react';
import useViewportVisibility from 'src/hooks/use-viewport-visibility';
import { useMostPurchasedProducts } from './use-most-purchased-products';
import { GenericCarousel } from '../generic-carousel';

type MostPurchasedSectionProps = {
  dispensaryId: string;
};

export function MostPurchasedCarousel({ dispensaryId }: MostPurchasedSectionProps): JSX.Element | null {
  const { products, loading, error } = useMostPurchasedProducts({ dispensaryId });
  const { ref, hasBeenVisible } = useViewportVisibility();

  if (hasBeenVisible && !loading && (error || !products.length)) {
    return null;
  }

  const sectionProps = {
    section: {
      hideTitle: false,
    },
    hasBeenVisible,
    isLoading: loading,
    label: `Buy It Again`,
    products,
  };

  return <GenericCarousel ref={ref} {...sectionProps} />;
}
